import { connect } from 'react-redux';

//presentation component
import BreadCrumbs from './breadCrumbs'


const BreadCrumbsContainer = connect(null, null)(BreadCrumbs);
export default BreadCrumbsContainer;